// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({162: "company-create",34: "company-list",850: "company-details",}[chunkId] || chunkId) + "." + {162: "6c19d532e40f75c1",34: "107867d7ded62c85",788: "cc299ceda8fdcbfa",837: "ffa9bd076af66a7b",850: "b998305d9a8627d4",978: "b1b19afcedf34b41",}[chunkId] + ".js"
}